import React, {  Component } from 'react';

export default class RequestCreditUploadImageDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('RequestCreditUploadImageDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Photo Upload requirement</h2>
                        <p>Scrap units require pictures to be uploaded before submittal.  Pictures must show the serial tag removed, the damage/defect requiring the unit to be scrapped and proof that the unit is inoperable.
                        <br/>Files should each be less than 5000 KB (5MB) and be in one of these formats:  jpg, jpeg, gif, bmp</p>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/requestCreditUploadImageDialog.js